import React, { useEffect } from 'react';
import SingleRateCardView from './SingleRateCardView.jsx';
import { useParams } from 'react-router-dom-v5-compat';
import { loadRateCard, selectRateCard } from '../../RateCardPageViewSlice';
import { useSelector } from 'react-redux';
import { RatesDespatch } from '../../../Redux/RatesStore.js';
import { useRatesDispatch } from "../../../Redux/RatesHooks";

export default function RateCardPageView() {
    const dispatch: RatesDespatch = useRatesDispatch();
    const { rateCardId } = useParams<{ rateCardId: string | undefined }>();
    const rateCard = useSelector(selectRateCard);

    useEffect(() => {
        if (rateCardId) {
            dispatch(loadRateCard(rateCardId));
        }
    }, [dispatch, rateCardId]);

    return (
        <SingleRateCardView rateCard={rateCard} />
    );
}
